import { connect } from 'react-redux';
import Footer from 'components/Footer';

const mapStateToProps = (state) => {
  const { companyInfo, social } = state.website;
  const name = companyInfo ? companyInfo.name : "";
  const address = companyInfo ? companyInfo.address : "";
  const email = companyInfo ? companyInfo.email : "";
  const phones = companyInfo && companyInfo.phones;

  let tel = phones && phones.find(x => x.type === "Tel");
  let fax = phones && phones.find(x => x.type === "Fax");
  tel = tel && tel.number;
  fax = fax && fax.number;

  let twitter = social && social.find(x => x.type === 'TWITTER');
  let facebook = social && social.find(x => x.type === 'FACEBOOK');
  let youtube = social && social.find(x => x.type === 'YOUTUBE');
  let instagram = social && social.find(x => x.type === 'INSTAGRAM');
  twitter = twitter && twitter.url;
  facebook = facebook && facebook.url;
  youtube = youtube && youtube.url;
  instagram = instagram && instagram.url;

  return {
    name,
    address,
    email,
    tel,
    fax,
    twitter,
    facebook,
    youtube,
    instagram
  }
};

const mapDispatchToProps = dispatch => {
  return {

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);


// WEBPACK FOOTER //
// ./src/containers/Footer.container.js